import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OutstandingStateSummaryService {
  constructor(private readonly http: HttpClient) {}
  getOutstandingStateSummaryData(): Observable<any> {
    return this.http.get('assets/data/uim-ui/outstanding-state.json');
  }
}
